import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid bg-dark text-white py-5 px-sm-3 px-md-5">
        <div className="row pt-5">

          {/* Get In Touch */}
          <div className="col-lg-3 col-md-6 mb-5">
            <h4 className="text-primary mb-4">Get In Touch</h4>

            <p><i className="fa fa-map-marker-alt mr-2"></i>Gandhi Nagar, Utraula Bazar
            Utraula, Balrampur – 271604
            Uttar Pradesh, India</p>
            <p><i className="fa fa-phone-alt mr-2"></i>+91 78002 60986, +91 98244-40003</p>
            <p><i className="fa fa-envelope mr-2"></i>ecigroupindia@gmail.com</p>

            <div className="d-flex justify-content-start mt-4">
              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0"
                style={{ width: "38px", height: "38px" }} href="#">
                <i className="fab fa-twitter"></i>
              </a>

              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0"
                style={{ width: "38px", height: "38px" }} href="#">
                <i className="fab fa-facebook-f"></i>
              </a>

              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0"
                style={{ width: "38px", height: "38px" }} href="#">
                <i className="fab fa-linkedin-in"></i>
              </a>

              <a className="btn btn-outline-light rounded-circle text-center mr-2 px-0"
                style={{ width: "38px", height: "38px" }} href="#">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6 mb-5">
            <h4 className="text-primary mb-4">Quick Links</h4>

            <div className="d-flex flex-column justify-content-start">
              <Link className="nav-item nav-link" to="/"><i className="fa fa-angle-right mr-2"></i>Home</Link>
              <Link className="nav-item nav-link" to="/about"><i className="fa fa-angle-right mr-2"></i>About Us</Link>
              <Link className="nav-item nav-link" to="/services"><i className="fa fa-angle-right mr-2"></i>Our Services</Link>
              <Link className="nav-item nav-link" to="/projects"><i className="fa fa-angle-right mr-2"></i>Our Projects</Link>
              <Link className="nav-item nav-link" to="/contact"><i className="fa fa-angle-right mr-2"></i>Contact Us</Link>
            </div>
          </div>

          {/* Popular Links */}
          <div className="col-lg-3 col-md-6 mb-5">
            <h4 className="text-primary mb-4">Popular Links</h4>

             <div className="d-flex flex-column justify-content-start">
              <Link className="nav-item nav-link" to="/"><i className="fa fa-angle-right mr-2"></i>Home</Link>
              <Link className="nav-item nav-link" to="/about"><i className="fa fa-angle-right mr-2"></i>About Us</Link>
              <Link className="nav-item nav-link" to="/services"><i className="fa fa-angle-right mr-2"></i>Our Services</Link>
              <Link className="nav-item nav-link" to="/projects"><i className="fa fa-angle-right mr-2"></i>Our Projects</Link>
              <Link className="nav-item nav-link" to="/contact"><i className="fa fa-angle-right mr-2"></i>Contact Us</Link>
            </div>
          </div>

          {/* Newsletter */}
          <div className="col-lg-3 col-md-6 mb-5">
            <h4 className="text-primary mb-4">Newsletter</h4>

            <form>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Your Name"
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  className="form-control border-0"
                  placeholder="Your Email"
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-lg btn-primary btn-block border-0"
              >
                Submit Now
              </button>
            </form>
          </div>

        </div>

        {/* Bottom Copyright */}
        <div className="container border-top border-secondary pt-5">
          <p className="m-0 text-center text-white">
            {/* &copy; <a className="text-white font-weight-bold" href="#">Your Site Name</a>. */}
            © 2025 Engineering Construction and Interiors Pvt. Ltd. All rights reserved.{" "}
            {/* <a className="text-white font-weight-bold" href="https://htmlcodex.com">
              HTML Codex
            </a> */}
          </p>
        </div>
      </div>
      {/* Footer End */}


      {/* Back to Top */}
      <a href="#" className="btn btn-lg btn-primary back-to-top">
        <i className="fa fa-angle-double-up"></i>
      </a>
    </>
  );
};

export default Footer;